import React from 'react';
import PropTypes from 'prop-types';

const Avatar = ({ backgroundId, lastName, firstName }) => {
	const stringToHslColor = (str, s, l) => {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		const h = hash % 360;
		return `hsl(${h}, ${s}%, ${l}%)`;
	};

	const generateAvatarInitials = () => {
		if (lastName !== undefined && lastName !== null && lastName.length > 0) {
			return lastName.substring(0, 1) + firstName.substring(0, 1);
		}
		return firstName.substring(0, 2).toUpperCase();
	};

	return (
		<div
			style={{
				height: '30px',
				width: '30px',
				lineHeight: '30px',
				textAlign: 'center',
				borderRadius: '25px',
				background: stringToHslColor(`${backgroundId}`, 70, 80)
			}}
		>
			{generateAvatarInitials()}
		</div>
	);
};

Avatar.propTypes = {
	backgroundId: PropTypes.string.isRequired,
	lastName: PropTypes.string.isRequired,
	firstName: PropTypes.string.isRequired
};

export default Avatar;
